import { gql } from '@/modes/common/gql';
import type { ResultOf } from 'gql.tada';

const SECURITY_SETTINGS_DOCUMENT = `
  query SecuritySettings {
    session {
      userProfile {
        id
        phones {
          id
          subType
          value
        }
      }
    }
    securitySettings {
      hasPassword
      emailVerified
      phone
      twoFactorEnabled
      twoFactorMethod
      googleAccount {
        id
        email
      }
      passkeys {
        id
        device
        createdAt
        lastUsedAt
      }
    }
  }
` as const;

const DELETE_PASSKEY_DOCUMENT = `
  mutation DeletePasskey($id: ID!) {
    deletePasskey(id: $id)
  }
` as const;

const SET_TWO_FACTOR_METHOD_DOCUMENT = `
  mutation SetTwoFactorMethod($method: TwoFactorMethod!) {
    setTwoFactorMethod(method: $method)
  }
` as const;

const REMOVE_PHONE_DOCUMENT = `
  mutation RemovePhone($password: String!) {
    removePhone(password: $password)
  }
` as const;

export const SECURITY_SETTINGS = gql(SECURITY_SETTINGS_DOCUMENT);
export const DELETE_PASSKEY = gql(DELETE_PASSKEY_DOCUMENT);
export const SET_TWO_FACTOR_METHOD = gql(SET_TWO_FACTOR_METHOD_DOCUMENT);
export const REMOVE_PHONE = gql(REMOVE_PHONE_DOCUMENT);

export type Passkey = ResultOf<
  typeof SECURITY_SETTINGS
>['securitySettings']['passkeys'][number];
